import React from 'react';
import PropTypes from 'prop-types';

import Logo from '../../../../../../../../components/global/Logo';
import { UPLOAD_MODE } from '../../../../../../../../constants/album-folder-photos';
import BoxedArrowLink from '../../../../../../../../components/global/BoxedArrowLink';
import { canShareEntity } from '../../../../../../../../util/product-permissions';
import { CONTRIBUTOR_SHARE_MODAL } from '../../../../../../../../constants/modals';
import useAlbumSlideshow from '../../../../../Album/AlbumSlideshow/hooks/useAlbumSlideshow';
import Spinner from '../../../../../../../../components/global/Spinner';

const propTypes = {
  basename: PropTypes.string,
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
  }),
  uploadMode: PropTypes.oneOf(Object.values(UPLOAD_MODE)),
  onRequestClose: PropTypes.func,
  openModal: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  target: PropTypes.shape({
    album: PropTypes.shape({
      id: PropTypes.string,
    }),
    album_photo_group: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

const MemoryBookUploadSuccess = ({
  basename,
  albumFolder,
  uploadMode,
  onRequestClose,
  openModal,
  history,
  target,
}) => {
  const { album, album_photo_group: photoGroup } = target;
  const { loading } = useAlbumSlideshow({ albumId: album.id });

  if (loading) {
    return (
      <div className="text-center py-2">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="d-flex flex-column">
      <Logo iconOnly className="mr-auto mb-3" imageProps={{ height: '50px' }} />
      <h4 className="text-black text-dark">Your photos have been uploaded!</h4>
      {uploadMode === UPLOAD_MODE.REVIEW && (
        <p>
          Your unpublished photos can be found within the Unpublished section in
          your folder&rsquo;s menu.
        </p>
      )}

      <p className="text-dark text-bold">What to do next?</p>
      <div className="d-flex flex-column flex-md-row">
        <BoxedArrowLink
          className="mr-0 mr-md-2"
          onClick={() => {
            history.push({
              pathname: `/app/${basename}/albums/${album.id}/upload`,
              state: {
                album,
                photoGroup,
              },
            });

            onRequestClose?.();
          }}
        >
          Upload More Photos
        </BoxedArrowLink>
        {canShareEntity(albumFolder) && (
          <BoxedArrowLink
            onClick={() => {
              onRequestClose?.();
              openModal(CONTRIBUTOR_SHARE_MODAL);
            }}
            className="mt-2 mt-md-0"
          >
            Request Photos
          </BoxedArrowLink>
        )}
      </div>
    </div>
  );
};

MemoryBookUploadSuccess.propTypes = propTypes;

export default MemoryBookUploadSuccess;
